import React from "react";
import { Tag } from "primereact/tag";
import styled from "styled-components";

interface StatusTagProps {
  status: "success" | "warning" | "danger" | "info" | "secondary";
  label: string;
}

const StyledTag = styled(Tag)<{ $status: StatusTagProps["status"] }>`
  .p-tag-value {
    color: ${({ $status }) => {
      switch ($status) {
        case "success":
          return "#196307";
        case "warning":
          return "#9C6519";
        case "danger":
          return "#EA4646";
        case "info":
          return "#0c5460";
        default:
          return "#333";
      }
    }};
    font-weight: 550;
  }

  background-color: ${({ $status }) => {
    switch ($status) {
      case "success":
        return "#E1F8DC";
      case "warning":
        return "#FFF2AA";
      case "danger":
        return "#FFEAE7";
      case "info":
        return "#D1ECF1";
      default:
        return "#e9ecef";
    }
  }};
`;

const StatusTag: React.FC<StatusTagProps> = ({ status, label }) => {
  return <StyledTag value={label} severity={status} $status={status} />;
};

export default StatusTag;
